module.exports = "/images/loginBG.png?0ef0c049902b3f7ab2373115bbac4148";